import UserSession from '@/plugins/user-session';

export default class Bootstrapper {
	public static async bootstrap(): Promise<void> {
		// If MooTools is loaded, the functionality below won't work. Since it's only used for standalone logins, we can safely bail out.
		if (this.isMooToolsLoaded) {
			return;
		}

		if (!UserSession.isValid()) {
			const error = new Error('No valid session found');
			error.name = 'NotAuthorizedException';
			throw error;
		}

		await UserSession.acquireCredentials();
	}

	private static get isMooToolsLoaded(): boolean {
		return typeof Request === 'undefined' || !Object.prototype.hasOwnProperty.call(Request.prototype, 'keepalive');
	}
}
